import EmployeeSearchResultItem from "./EmployeeSearchResultItem";

export default EmployeeSearchResultItem;
